import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import { getCriticalNotes } from 'api/patient';

// ----------------------------------------------------------------------

const initialState = {
    criticalNotes: {
        error: null,
        loaded: false,
        data: {}
    }
};

const slice = createSlice({
    name: 'patientCriticalNotes',
    initialState,
    reducers: {
        setPatientCriticalNotesError(state, action) {
            state.criticalNotes.error = action.payload;
            state.criticalNotes.loaded = true;
        },

        getPatientCriticalNotesSuccess(state, action) {
            state.criticalNotes.data = action.payload;
            state.criticalNotes.loaded = true;
        },

        resetState(state) {
            state.criticalNotes = initialState.criticalNotes;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function patientCriticalNotesResetState() {
    return dispatch(slice.actions.resetState());
}

export function patientCriticalNotes(patientId) {
    return async () => {
        try {
            const response = await getCriticalNotes(patientId);
            dispatch(slice.actions.getPatientCriticalNotesSuccess(response.data.criticalNotes));
        } catch (error) {
            dispatch(slice.actions.setPatientCriticalNotesError(error));
        }
    };
}
